import { AxiosError, AxiosResponse } from 'axios'

import ApiService from '.'
import { memberService } from '../member'
import { dialog } from '../ui/dialog'
import { moveToLoginPage } from '@/utils/moveToLoginPage'
import { storyCardTooltipStore } from '@/store/ui/storycard-tooltip.store'
import { getArtistLastPage } from '@/utils/artist-pathname'

export const interceptorsRequestConfig = (config: any) => {
  return {
    ...config,
    headers: {
      Authorization: memberService.getAccessToken() ? `Bearer ${memberService.getAccessToken()}` : '',
    },
  }
}

export const interceptorsRequestRejected = async (error: AxiosError) => {
  return Promise.reject(error)
}

export const interceptorsResponseOutFilled = (response: AxiosResponse<any, any>): AxiosResponse<any, any> => {
  return response
}

export const interceptorsResponseRejected = async (error: AxiosError) => {
  if (error.status === 401) {
    storyCardTooltipStore.setState({ storyCardTooltipFirstVisibleIdList: [] })

    const logoutConfirmed = await dialog.openMessage({
      title: '로그인 인증이 만료되었어요.',
      message: '다시 로그인해 주세요.',
      confirmMessage: '로그인',
      cancelMessage: '취소',
      cancelVisible: true,
    })

    memberService.logout()

    if (logoutConfirmed) {
      moveToLoginPage()
    } else {
      window.location.href = `/${getArtistLastPage()}`
    }

    return Promise.reject(error)
  }

  if ([500].includes(error.status || 200)) {
    window.location.href = '/error/network'

    return Promise.reject(error)
  }

  return Promise.reject(error)
}

const apiService = new ApiService({
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000',
  interceptorsRequestConfig,
  interceptorsRequestRejected,
  interceptorsResponseOutFilled,
  interceptorsResponseRejected,
})

export default apiService
